import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import BootstrapVue from 'bootstrap-vue'
import Vuebar from 'vuebar'
import VueLoading from 'vuejs-loading-plugin'
import CustomLoader from "./components/CustomLoader";
import i18n from './i18n'
import moment from "moment";
import 'moment/locale/hu';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueTheMask from 'vue-the-mask'
import VueTelInput from 'vue-tel-input'
import Select2 from 'v-select2-component';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import VueClipboard from 'vue-clipboard2'
import FormInputFormat from "./components/FormInputFormat";
import KonamiCode from 'vue-konami-code'
import UserUtil from "./util/UserUtil";
import VueRouter from 'vue-router'

// Patch push to avoid NavigationDuplicated errors
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

// Axios config

const errorHandler = (error) => {
    console.error('error', error);

    if (error.response?.data?.type === 'EESZT_UNAVAILABLE') {
        Vue.prototype.$toast.error({
            title: 'EESZT hiba',
            message: error.response.data.reason
        });
        error.response.data.reason = null;
        return Promise.reject({ ...error });
    }

    if (error.response.status === 403){
        let logout = {logout: true};
        router.push({name: 'Login', params: logout});
    }

    return Promise.reject({ ...error })
};

const successHandler = (response) => {

    if(response.data && typeof response.data === 'string' && response.data.includes("We're sorry but vuex-auth doesn't work properly without JavaScript enabled.")){
        router.go();
    }

    return response
};

Axios.defaults.params = {};

Axios.interceptors.request.use(
    function (config) {

        const token = localStorage.getItem('token');

        if (token) {
            if( !!store.getters['userModel/getUser'] && !UserUtil.checkUserRole()) {
                let logout = {logout: true};
                router.push({name: 'Login', params: logout});
            }
            config.headers.authorization =  token;
        }

        config.params['timestamp'] = new Date().valueOf();

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
);

moment.locale('hu')
Vue.prototype.$moment = moment

Vue.prototype.$http = Axios;


Vue.use(KonamiCode, {callback: function () {
    try {
        $("#footer-logo").wrap('<a href="https://www.youtube.com/watch?v=3X-iqFRGqbc" target="_blank">');
        document.getElementById("footer-logo").src=require('./assets/images/Lanoga-logo-mirror.png');
    } catch (e) {
        console.error(e)
    }
}})

VueClipboard.config.autoSetContainer = true 
Vue.use(VueClipboard)

Vue.use(CxltToastr, {
    position: 'bottom right',
    timeOut: 8000
});
Vue.use(BootstrapVue);
Vue.use(Vuebar);
Vue.use(VueQuillEditor);
Vue.use(VueTheMask);
Vue.use(VueTelInput);
Vue.use(VueLoading, {
    classes: 'custom-loader',
    customLoader: CustomLoader,
    background: 'rgba(255, 255, 255, 0.3)',
});
Vue.use(datePicker);

Vue.component('Select2', Select2);
Vue.component('FormInputFormat', FormInputFormat)

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error("GLOBAL ERROR:", err, info);
};
window.addEventListener("error", e => {
  console.error("WINDOW ERROR:", e.error);
});
window.addEventListener("unhandledrejection", e => {
  console.error("PROMISE ERROR:", e.reason);
});

export default new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
